/**
 * Intelligems A/B — Shoe Finder (homepage)
 *
 * Control (Test A, default): section hidden.
 * Group 1 (Test B): show Shoe Finder directly below the
 * "Improving over 100,000+ lives" image banners.
 *
 * Intelligems inject (Group 1):
 *   document.body.setAttribute('data-ig-shoe-finder', 'true');
 */
(function () {
  'use strict';

  if (window.__igShoeFinderBooted) return;
  window.__igShoeFinderBooted = true;

  var ATTR = 'data-ig-shoe-finder';
  var MARK = 'data-ig-shoe-finder-bound';

  // Desktop + mobile "Improving over 100,000+ lives" banners
  var ANCHOR_SECTION_IDS = [
    'image_banner_cDRrhD',
    'image_banner_nUJgHr'
  ];

  var CATEGORY_COLLECTIONS = {
    Sandals: 'orthopedic-shoes',
    Insoles: 'accessories',
    Boots: 'wintershoe',
    Shoes: 'orthopedic-shoes',
    Socks: 'accessories'
  };

  var GENDER_COLLECTIONS = {
    Women: 'women',
    Men: 'orthopedic-shoes'
  };

  function isEnabled() {
    var value = (document.body && document.body.getAttribute(ATTR) || '').trim().toLowerCase();
    return value === 'true' || value === '1' || value === 'on' || value === 'yes';
  }

  function findSectionByKey(key) {
    return (
      document.getElementById('shopify-section-' + key) ||
      document.querySelector('[id*="' + key + '"]')
    );
  }

  function findAnchorSection() {
    var found = [];
    ANCHOR_SECTION_IDS.forEach(function (key) {
      var el = findSectionByKey(key);
      if (el) found.push(el);
    });

    if (!found.length) return null;

    // Place after the last matching banner in DOM order
    // so both desktop + mobile variants stay above Shoe Finder.
    found.sort(function (a, b) {
      if (a === b) return 0;
      return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });

    return found[found.length - 1];
  }

  function placeAfterLivesSection(section) {
    var anchor = findAnchorSection();
    if (!anchor) return;

    var wrapper = section.closest('.shopify-section') || section;
    if (!wrapper || wrapper === anchor || anchor.nextElementSibling === wrapper) return;

    anchor.insertAdjacentElement('afterend', wrapper);
  }

  function getValue(select) {
    return select && select.value ? String(select.value).trim() : '';
  }

  function formIsComplete(form) {
    return !!(
      getValue(form.querySelector('[data-ig-shoe-finder-gender]')) &&
      getValue(form.querySelector('[data-ig-shoe-finder-condition]')) &&
      getValue(form.querySelector('[data-ig-shoe-finder-category]')) &&
      getValue(form.querySelector('[data-ig-shoe-finder-activity]'))
    );
  }

  function buildDestinationUrl(form) {
    var gender = getValue(form.querySelector('[data-ig-shoe-finder-gender]'));
    var condition = getValue(form.querySelector('[data-ig-shoe-finder-condition]'));
    var category = getValue(form.querySelector('[data-ig-shoe-finder-category]'));
    var activity = getValue(form.querySelector('[data-ig-shoe-finder-activity]'));

    var collection = GENDER_COLLECTIONS[gender] || 'orthopedic-shoes';
    if (category && CATEGORY_COLLECTIONS[category]) {
      collection = CATEGORY_COLLECTIONS[category];
    }

    var searchTerms = [];
    if (gender) searchTerms.push(gender);
    if (condition) searchTerms.push(condition);
    if (category && category !== 'Shoes') searchTerms.push(category);
    if (activity) searchTerms.push(activity);
    searchTerms.push('shoes');

    var hasSpecificCollection =
      collection !== 'orthopedic-shoes' ||
      (category && ['Boots', 'Insoles', 'Socks'].indexOf(category) !== -1);

    if (hasSpecificCollection && !condition && !activity) {
      return '/collections/' + collection;
    }

    return '/search?type=product&q=' + encodeURIComponent(searchTerms.join(' '));
  }

  function updateSubmitState(form) {
    var submit = form.querySelector('[data-ig-shoe-finder-submit]');
    if (!submit) return;
    submit.disabled = !formIsComplete(form);
  }

  function bindForm(form) {
    if (form.getAttribute(MARK) === '1') return;
    form.setAttribute(MARK, '1');

    var fields = form.querySelectorAll('select');
    fields.forEach(function (field) {
      field.addEventListener('change', function () {
        updateSubmitState(form);
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!formIsComplete(form)) return;
      window.location.assign(buildDestinationUrl(form));
    });

    updateSubmitState(form);
  }

  function applyVisibility() {
    var enabled = isEnabled();
    document.querySelectorAll('[data-ig-shoe-finder-section]').forEach(function (section) {
      section.setAttribute('aria-hidden', enabled ? 'false' : 'true');
    });
  }

  function boot() {
    if (!document.body) return;

    var section = document.querySelector('[data-ig-shoe-finder-section]');
    if (section) {
      placeAfterLivesSection(section);
    }

    document.querySelectorAll('[data-ig-shoe-finder-form]').forEach(bindForm);
    applyVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  function watchBodyAttribute() {
    if (!document.body) {
      document.addEventListener('DOMContentLoaded', watchBodyAttribute, { once: true });
      return;
    }

    new MutationObserver(function () {
      boot();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [ATTR],
      childList: true,
      subtree: true
    });
  }

  watchBodyAttribute();

  window.IgShoeFinder = {
    enable: function () {
      if (!document.body) return;
      document.body.setAttribute(ATTR, 'true');
      boot();
    },
    disable: function () {
      if (!document.body) return;
      document.body.removeAttribute(ATTR);
      boot();
    },
    buildDestinationUrl: buildDestinationUrl,
    isEnabled: isEnabled,
    apply: boot
  };
})();
